import {
  MEMBER_ROLE_LABELS,
  MEMBER_ROLE_OPTIONS,
  formatAmount,
  formatPhoneEmail,
} from '../futures/futuresOrderConstants';
import {
  inputDateTimeToQueryApi,
  toInputDateTime,
} from '../futures/futuresRoundConstants';

/** 線上充值主狀態 / 回調狀態（PaymentStatusType） */
export const ONLINE_DEPOSIT_STATUS_OPTIONS = [
  { value: 'PENDING', label: '待處理' },
  { value: 'PROCESSING', label: '處理中' },
  { value: 'WAITING_CALLBACK', label: '待回調' },
  { value: 'SUCCESS', label: '成功' },
  { value: 'FAIL', label: '失敗' },
  { value: 'REJECT', label: '拒絕' },
  { value: 'TIMEOUT', label: '超時' },
  { value: 'EXCEPTION', label: '異常' },
  { value: 'NONE', label: '無狀態' },
];

export const ONLINE_DEPOSIT_STATUS_LABELS = Object.fromEntries(
  ONLINE_DEPOSIT_STATUS_OPTIONS.map((item) => [item.value, item.label])
);

export { MEMBER_ROLE_LABELS, MEMBER_ROLE_OPTIONS, formatAmount, formatPhoneEmail };

const MAX_QUERY_DAYS = 31;

export function defaultOnlineDepositApplyTimeRange() {
  const now = new Date();
  const from = new Date(now);
  from.setHours(0, 0, 0, 0);

  const to = new Date(now);
  to.setDate(to.getDate() + 1);
  to.setHours(0, 0, 0, 0);

  return {
    createTimeFromInput: toInputDateTime(from),
    createTimeToInput: toInputDateTime(to),
  };
}

function calendarDaysBetween(fromInput, toInput) {
  const fromDate = fromInput.slice(0, 10);
  const toDate = toInput.slice(0, 10);
  const from = new Date(`${fromDate}T00:00:00`);
  const to = new Date(`${toDate}T00:00:00`);
  return Math.round((to - from) / (24 * 60 * 60 * 1000));
}

export function validateOnlineDepositTimeRange(fromInput, toInput, label = '申請時間') {
  if (!fromInput && !toInput) {
    return '';
  }
  if ((fromInput && !toInput) || (!fromInput && toInput)) {
    return `${label}起迄需同時填寫`;
  }
  const fromApi = inputDateTimeToQueryApi(fromInput);
  const toApi = inputDateTimeToQueryApi(toInput);
  if (fromApi > toApi) {
    return `${label}起不可晚於迄`;
  }
  const days = calendarDaysBetween(fromInput, toInput);
  if (days > MAX_QUERY_DAYS) {
    return `${label}跨度不可超過 ${MAX_QUERY_DAYS} 天`;
  }
  return '';
}

export function buildOnlineDepositPageParams(pageNo, filters) {
  const params = {
    pageNo,
    pageSize: 15,
  };

  if (filters.id?.trim()) {
    params.id = Number(filters.id);
  }
  if (filters.thirdRecordCode?.trim()) {
    params.thirdRecordCode = filters.thirdRecordCode.trim();
  }
  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.callbackStatus) {
    params.callbackStatus = filters.callbackStatus;
  }
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.topInviterId?.trim()) {
    params.topInviterId = Number(filters.topInviterId);
  }
  if (filters.inviterId?.trim()) {
    params.inviterId = Number(filters.inviterId);
  }
  if (filters.memberId?.trim()) {
    params.memberId = Number(filters.memberId);
  }
  if (filters.phoneEmail?.trim()) {
    params.phoneEmail = filters.phoneEmail.trim();
  }
  if (filters.currencyName?.trim()) {
    params.currencyName = filters.currencyName.trim();
  }
  if (filters.address?.trim()) {
    params.address = filters.address.trim();
  }
  if (filters.createTimeFromInput) {
    params.createTimeBegin = inputDateTimeToQueryApi(filters.createTimeFromInput);
  }
  if (filters.createTimeToInput) {
    params.createTimeEnd = inputDateTimeToQueryApi(filters.createTimeToInput);
  }
  if (filters.updateTimeFromInput) {
    params.updateTimeBegin = inputDateTimeToQueryApi(filters.updateTimeFromInput);
  }
  if (filters.updateTimeToInput) {
    params.updateTimeEnd = inputDateTimeToQueryApi(filters.updateTimeToInput);
  }
  if (filters.callbackTimeFromInput) {
    params.callbackTimeBegin = inputDateTimeToQueryApi(filters.callbackTimeFromInput);
  }
  if (filters.callbackTimeToInput) {
    params.callbackTimeEnd = inputDateTimeToQueryApi(filters.callbackTimeToInput);
  }

  return params;
}

export function formatDepositStatus(status) {
  if (!status) {
    return '—';
  }
  const code = typeof status === 'string' ? status : status?.name || status?.code || status;
  return ONLINE_DEPOSIT_STATUS_LABELS[code] || code;
}

export function formatOptionalId(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

export function depositStatusClassName(status) {
  const code = String(typeof status === 'string' ? status : status?.name || status || '').toUpperCase();
  if (code === 'SUCCESS') {
    return 'text-profit';
  }
  if (code === 'FAIL' || code === 'REJECT' || code === 'TIMEOUT' || code === 'EXCEPTION') {
    return 'text-loss';
  }
  if (code === 'PENDING' || code === 'PROCESSING' || code === 'WAITING_CALLBACK') {
    return 'text-pending';
  }
  return '';
}
